import React, { useState } from "react";

const VideoReviewCard = ({ review }) => {
  const [play, setPlay] = useState(false);

  return (
    <div className="video-review-card">
      {!play ? (
        <div
          className="video-thumbnail"
          role="button"
          tabIndex={0}
          onClick={() => setPlay(true)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") setPlay(true);
          }}
        >
          <img
            src={`https://img.youtube.com/vi/${review.videoId}/hqdefault.jpg`}
            alt={review.title}
          />
          <span className="play-btn">▶</span>
        </div>
      ) : (
        <div className="video-frame">
          <iframe
            src={`https://www.youtube.com/embed/${review.videoId}?autoplay=1`}
            title={review.title}
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </div>
      )}

      <div className="review-info">
        <h4>{review.title}</h4>
        <p>{review.course}</p>
        <p>{"⭐".repeat(review.rating)}</p>
        <a
          href={`https://www.youtube.com/watch?v=${review.videoId}`}
          target="_blank"
          rel="noopener noreferrer"
          className="video-review-link"
        >
          <i className="fa fa-youtube-play" aria-hidden="true" /> Watch on YouTube
        </a>
      </div>
    </div>
  );
};

export default VideoReviewCard;
